import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/product-hunt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M326.3 218.8C326.3 239.3 309.6 256 289.1 256H218.8V181.6H289.1C309.6 181.6 326.3 198.3 326.3 218.8zM504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM375.9 218.8C375.9 170.9 337 132 289.1 132H169.2V380H218.8V305.6H289.1C337 305.6 375.9 266.7 375.9 218.8z'
      }
    ]
  }
})
